/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import React, { useState } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Switch, Tooltip, CircularProgress, Grid } from "@mui/material";
import { DetailedUser, Setter } from "../../../utils/Interfaces";
import { modifyUserRole, refreshUsers } from "./userManagementFunctions";
import { delayedAction } from "../../../utils/Functions";
import { useAppDispatch } from "../../../app/hooks";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";

export interface UserRoleItemToggleProps {
    value: boolean;
    roleKey: string;
    label: string;
    setter: Setter<boolean>;
    user: DetailedUser;
}

export const UserRoleItemToggle = (props: UserRoleItemToggleProps) => {
    const { value, roleKey, label, user } = props;

    const dispatch: Dispatch<AnyAction> = useAppDispatch();

    const [loading, setLoading] = useState<boolean>(false);

    return (
        <Grid container>
            <Grid xs={3} item>
                <FormControlLabel
                    label={label}
                    // @ts-ignore TODO
                    type="switch"
                    control={
                        <Tooltip title={`${value ? "Disable" : "Enable"} ${label} Role`}>
                            <>
                                {loading && (
                                    <CircularProgress
                                        size={14}
                                        sx={{
                                            ml: 2.75,
                                            mr: 2.75,
                                            mt: 1.25,
                                            mb: 1.75,
                                        }}
                                    />
                                )}
                                {!loading && (
                                    <Switch
                                        checked={value}
                                        onChange={(event) => {
                                            modifyUserRole(
                                                roleKey,
                                                event.target.checked,
                                                user.id,
                                                dispatch,
                                                () =>
                                                    refreshUsers(dispatch, (isLoading: boolean) => {
                                                        if (!isLoading) {
                                                            delayedAction(300, () => setLoading(isLoading));
                                                        } else {
                                                            setLoading(isLoading);
                                                        }
                                                    }),
                                                (isLoading: boolean) => {}
                                            );
                                        }}
                                        inputProps={{ "aria-label": "controlled" }}
                                    />
                                )}
                            </>
                        </Tooltip>
                    }
                />
            </Grid>
        </Grid>
    );
};
